import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-subscription-upgrade-dialog',
  templateUrl: './subscription-upgrade-dialog.component.html',
  styleUrls: ['./subscription-upgrade-dialog.component.scss'],
})
export class SubscriptionUpgradeDialogComponent implements OnInit {

  constructor(private _dialog: MatDialogRef<SubscriptionUpgradeDialogComponent>) {
  }

  ngOnInit() {
  }

  public closeDialog() {
    this._dialog.close();
  }
}
